import counterpart from 'counterpart';

export function mapDataAccessList(listToAugment = [], mainLineField = 'label', subLineField = null, isMultiCorp = false, isExternalUser = false, isGlobalSelector = false) {
  if (isGlobalSelector) {
    if (isExternalUser) {
      if (isMultiCorp === true) {
        if (listToAugment[0].orgLevelIndex === 0 && listToAugment[0].id !== -1) {
          listToAugment.splice(0, 0, {
            id: -1,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 0,
            organizations: [{ id: -2,
              label: counterpart('globalTranslate.globalSelectorFlag.all'),
              hasAccess: true,
              orgLevelIndex: 4,
              organizations: [{ id: -3,
                label: counterpart('globalTranslate.globalSelectorFlag.all'),
                hasAccess: true,
                orgLevelIndex: 5,
                organizations: [] }] }] });
        } else if (listToAugment[0].orgLevelIndex === 4 && listToAugment[0].id !== -2) {
          listToAugment.splice(0, 0, { id: -2,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 4,
            organizations: [{ id: -3, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] });
        } else if (listToAugment[0].orgLevelIndex === 5 && listToAugment[0].id !== -3) {
          listToAugment.splice(0, 0, { id: -3, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] });
        }
      } else if (isMultiCorp === false) {
        if (listToAugment[0].orgLevelIndex === 4 && listToAugment[0].id !== -1) {
          listToAugment.splice(0, 0, { id: -1,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 4,
            organizations: [{ id: -2, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] });
        } else if (listToAugment[0].orgLevelIndex === 5 && listToAugment[0].id !== -2) {
          listToAugment.splice(0, 0, { id: -2, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] });
        }
      }
    } else if (listToAugment[0].orgLevelIndex === 0 && listToAugment[0].id !== -1) {
      listToAugment.splice(0, 0, {
        id: -1,
        label: counterpart('globalTranslate.globalSelectorFlag.all'),
        hasAccess: true,
        orgLevelIndex: 0,
        organizations: [{ id: -2,
          label: counterpart('globalTranslate.globalSelectorFlag.all'),
          hasAccess: true,
          orgLevelIndex: 1,
          organizations: [{ id: -3,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 2,
            organizations: [{ id: -4,
              label: counterpart('globalTranslate.globalSelectorFlag.all'),
              hasAccess: true,
              orgLevelIndex: 3,
              organizations: [{ id: -5,
                label: counterpart('globalTranslate.globalSelectorFlag.all'),
                hasAccess: true,
                orgLevelIndex: 4,
                organizations: [{ id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] }] }] }] }] },
              );
    } else if (listToAugment[0].orgLevelIndex === 1 && listToAugment[0].id !== -2) {
      listToAugment.splice(0, 0, { id: -2,
        label: counterpart('globalTranslate.globalSelectorFlag.all'),
        hasAccess: true,
        orgLevelIndex: 1,
        organizations: [{ id: -3,
          label: counterpart('globalTranslate.globalSelectorFlag.all'),
          hasAccess: true,
          orgLevelIndex: 2,
          organizations: [{ id: -4,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 3,
            organizations: [{ id: -5,
              label: counterpart('globalTranslate.globalSelectorFlag.all'),
              hasAccess: true,
              orgLevelIndex: 4,
              organizations: [{ id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] }] }] }] });
    } else if (listToAugment[0].orgLevelIndex === 2 && listToAugment[0].id !== -3) {
      listToAugment.splice(0, 0, { id: -3,
        label: counterpart('globalTranslate.globalSelectorFlag.all'),
        hasAccess: true,
        orgLevelIndex: 2,
        organizations: [{ id: -4,
          label: counterpart('globalTranslate.globalSelectorFlag.all'),
          hasAccess: true,
          orgLevelIndex: 3,
          organizations: [{ id: -5,
            label: counterpart('globalTranslate.globalSelectorFlag.all'),
            hasAccess: true,
            orgLevelIndex: 4,
            organizations: [{ id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] }] }] });
    } else if (listToAugment[0].orgLevelIndex === 3 && listToAugment[0].id !== -4) {
      listToAugment.splice(0, 0, { id: -4,
        label: counterpart('globalTranslate.globalSelectorFlag.all'),
        hasAccess: true,
        orgLevelIndex: 3,
        organizations: [{ id: -5,
          label: counterpart('globalTranslate.globalSelectorFlag.all'),
          hasAccess: true,
          orgLevelIndex: 4,
          organizations: [{ id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] }] });
    } else if (listToAugment[0].orgLevelIndex === 4 && listToAugment[0].id !== -5) {
      listToAugment.splice(0, 0, { id: -5,
        label: counterpart('globalTranslate.globalSelectorFlag.all'),
        hasAccess: true,
        orgLevelIndex: 4,
        organizations: [{ id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] }] });
    } else if (listToAugment[0].orgLevelIndex === 5 && listToAugment[0].id !== -6) {
      listToAugment.splice(0, 0, { id: -6, label: counterpart('globalTranslate.globalSelectorFlag.all'), hasAccess: true, orgLevelIndex: 5, organizations: [] });
    }
  }

  if (!listToAugment || listToAugment === []) return listToAugment;

  return listToAugment.map((item) => {
    const mainLine = item[mainLineField] || ' ';
    const newItem = { ...item, mainLine };
    if (subLineField) {
      newItem.subLine = item[subLineField];
    }
    return newItem;
  });
}

/**
 * descend from a point in the data hierarchy, to find all merchants at the leaves
 * @param  {Array}  dataList   a segment of a data access hierarchy tree
 * @param  {Array}  parentIds  the beginning of an array to hold the lineage of
 *                             each merchant
 *                             (empty array if starting from a list of corps;,
 *                              otherwise, id of org whose child orgs are in first arg)
 * @return {Array}             a flat array of merchant objects from a data access
 *                             structure, with the lineage of org ids adding to each
 */
export function getAllSelectableMerchants(dataList, parentIds) {
  return dataList.reduce((list, org) => {
    let parentOrg;
    if (org.organizations.length) {
      // org has children, so dive deeper
      parentOrg = getAllSelectableMerchants(org.organizations, [...parentIds, org.id]);
    }

    if (parentOrg) {
      return list.concat(parentOrg);
    } else {
      // at a merchant "leaf", so add this to the list
      const foundMerchant = Object.assign({}, org);
      foundMerchant.parentIds = parentIds;
      return list.concat(foundMerchant);
    }
  }, []);
}

export function getNewSelectorFilter(dataList = []) {
  return {
    startData: dataList,
    corps: dataList,
    selectedCorp: null,
    regions: [],
    selectedRegion: null,
    principals: [],
    selectedPrincipal: null,
    associates: [],
    selectedAssociate: null,
    chains: [],
    selectedChain: null,
    availableMerchants: [],
    selectedMerchants: null,
  };
}

export function getNewSelectorFilterCorpChain(dataList = []) {
  return {
    startData: dataList,
    corps: dataList,
    selectedCorp: null,
    chains: [],
    selectedChain: null,
    availableMerchants: [],
    selectedMerchants: null,
  };
}

export function getNewSelectorFilterChain(dataList = []) {
  return {
    startData: dataList,
    chains: dataList,
    selectedChain: null,
    availableMerchants: [],
    selectedMerchants: null,
  };
}

export function getSelectedMerchantIds(filter, expandAll) {
  const selected = filter.currentRow[5].currentSelectedItem;
  if (selected && selected.length >= 1) {
    // one or more merchant ids are selected, return them
    return selected.map((m) => m.id);
  }

  // otherwise, all merchants is selected
  if (!expandAll) {
    return filter.currentRow[4].currentSelectedItem.id;
  } else {
    return filter.currentRow[5].currentData.map((m) => m.id);
  }
}

export function getOrgIdsForFirstAllSelection(filter) {
  for (let i = 1; i < 5; i += 1) {
    const selected = filter.currentRow[i].currentSelectedItem;
    if (!selected) {
      return filter.currentRow[i].currentData.map((o) => o.id);
    }
  }
  return [];
}

export function getParentOrgForFirstAllSelection(filter) {
  for (let i = 1; i < 5; i += 1) {
    const selected = filter.currentRow[i].currentSelectedItem;
    if (!selected) {
      return filter.currentRow[i - 1].currentSelectedItem;
    }
  }
  return null;
}

export function getLowestSelectedOrgs(dataList, orgIndex) {
  if (orgIndex > -1 && dataList[orgIndex] && dataList[orgIndex].currentSelectedItem !== null) {
    if (dataList[orgIndex].currentSelectedItem.id) {
      if (dataList[orgIndex].currentSelectedItem.id < 0) {
        let heirarchyIndex = orgIndex;
        while (heirarchyIndex >= 0) {
          const parentData = dataList[heirarchyIndex].currentSelectedItem;
          if (parentData.id > 0) {
            return parentData.id;
          }
          heirarchyIndex -= 1;
        }
      } else {
        return dataList[orgIndex].currentSelectedItem.id;
      }
    } else {
      return dataList[orgIndex].currentSelectedItem.reduce((list, filter) => {
        if (filter.id < 0) {
          return getLowestSelectedOrgs(dataList, --orgIndex);
        } else {
          const slectedOrgIds = filter.id;
          return list.concat(slectedOrgIds);
        }
      }, []);
    }
  } else {
    return getLowestSelectedOrgs(dataList, --orgIndex);
  }
  return [];
}

export function getLowestSelectedOrganization(data) {
  if (data.selectedMerchants !== null && data.selectedMerchants.length !== 0 && Array.isArray(data.selected)) {
    const selectedMerchants = data.selectedMerchants.filter((merchant) => {
      return (merchant.selected === true);
    });
    return filterIdsfromObject(selectedMerchants);
  } else if (data.selectedMerchants !== null && data.selectedMerchants.selected === true) {
    return data.selectedMerchants.id;
  } else
    if (data.selectedChain !== null && data.selectedChain.selected === true) { return data.selectedChain.id; } else
      if (data.selectedAssociate !== null && data.selectedAssociate.selected === true) { return data.selectedAssociate.id; } else
        if (data.selectedPrincipal !== null && data.selectedPrincipal.selected === true) { return data.selectedPrincipal.id; } else
          if (data.selectedRegion !== null && data.selectedRegion.selected === true) { return data.selectedRegion.id; } else
            if (data.selectedCorp !== null && data.selectedCorp.selected === true) { return data.selectedCorp.id; } else { return 0; }
}

export function filterIdsfromObject(dataObj) {
  const merIds = [];
  dataObj.filter((data) => {
    merIds.push(data.id);
  });
  return merIds;
}

export function getCurrentDataAccess(access = []) {
  const dataAccessRows = [];

  if (access) {
    access.forEach((corp) => {
      if (corp.hasAccess) {
        dataAccessRows.push({
          corp: Object.assign({}, corp, { endOfChain: true }),
          region: { label: 'All' },
          principal: { label: 'All' },
          associate: { label: 'All' },
          chain: { label: 'All' },
          merchant: { label: 'All' },
        });
      } else {
        corp.organizations.forEach((region) => {
          if (region.hasAccess) {
            dataAccessRows.push({
              corp,
              region: Object.assign({}, region, { endOfChain: true }),
              principal: { label: 'All' },
              associate: { label: 'All' },
              chain: { label: 'All' },
              merchant: { label: 'All' },
            });
          } else {
            region.organizations.forEach((principal) => {
              if (principal.hasAccess) {
                dataAccessRows.push({
                  corp,
                  region,
                  principal: Object.assign({}, principal, { endOfChain: true }),
                  associate: { label: 'All' },
                  chain: { label: 'All' },
                  merchant: { label: 'All' },
                });
              } else {
                principal.organizations.forEach((associate) => {
                  if (associate.hasAccess) {
                    dataAccessRows.push({
                      corp,
                      region,
                      principal,
                      associate: Object.assign({}, associate, { endOfChain: true }),
                      chain: { label: 'All' },
                      merchant: { label: 'All' },
                    });
                  } else {
                    associate.organizations.forEach((chain) => {
                      if (chain.hasAccess) {
                        dataAccessRows.push({
                          corp,
                          region,
                          principal,
                          associate,
                          chain: Object.assign({}, chain, { endOfChain: true }),
                          merchant: { label: 'All' },
                        });
                      } else {
                        dataAccessRows.push({
                          corp,
                          region,
                          principal,
                          associate,
                          chain: Object.assign({}, chain),
                          merchant: chain.organizations.filter((merchant) => merchant.hasAccess),
                          selectedMerchants: chain.organizations.filter((merchant) => merchant.hasAccess),
                          availableMerchants: [...chain.organizations],
                        });
                        // chain.organizations = chain.organizations.filter((merchant) => merchant.hasAccess);
                        // chain.organizations.forEach((merchant) => {
                        //   if (merchant.hasAccess) {
                        //     dataAccessRows.push({
                        //       corp,
                        //       region,
                        //       principal,
                        //       associate,
                        //       chain,
                        //       merchant: Object.assign({}, merchant, { endOfChain: true }),
                        //     });
                        //   }
                        // });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  return dataAccessRows;
}

export default {
  mapDataAccessList,
  getAllSelectableMerchants,
  getNewSelectorFilter,
  getNewSelectorFilterCorpChain,
  getNewSelectorFilterChain,
  getLowestSelectedOrgs,
  getCurrentDataAccess,
  getSelectedMerchantIds,
  getOrgIdsForFirstAllSelection,
  getParentOrgForFirstAllSelection,
};
